import { Grid } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectCurrentModDetails,
  selectIsEditExistingMod,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { TimeOffGrid } from './TimeOffGrid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { getFormattedTimeOff } from '../../ModificationsUtils';

export const TimeOffMod = () => {
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const isModEdit = useSelector(selectIsEditMod);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedModsDetails?.timeOffRequests && (isModEdit || isEditExistingMod))
      dispatch(placementModsAction.setEditTimeOffRows(getFormattedTimeOff(selectedModsDetails?.timeOffRequests)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModsDetails.timeOffRequests, isModEdit]);

  return (
    <>
      <Grid>
        <TimeOffGrid timeOffRequests={selectedModsDetails.timeOffRequests} />
      </Grid>
    </>
  );
};
